export default __webpack_public_path__ + "static/media/2.OPTIMIZACION_WEB_SFS.4e85a103.mp4";